import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";

interface RejectBatchEnrollmentInvitationParams {
  invitationId: string;
  rejectionReason: string;
}

export const rejectBatchEnrollmentInvitation = createAsyncThunk<
  void,
  RejectBatchEnrollmentInvitationParams,
  { extra: Partial<Dependencies> }
>("admin/batchEnrollmentInvitation/reject", async ({ invitationId, rejectionReason }, { extra: { adminRepository } }) => {
  await adminRepository!.rejectBatchEnrollmentInvitation(invitationId, rejectionReason);
});

export const resetRejectBatchEnrollmentInvitation = createAction("admin/batchEnrollmentInvitation/resetReject");
